import { AttachmentLogsCoreController } from './attachment-logs-core.controller'

function attachmentLogsCore () {
  return {
    restrict: 'E',
    templateUrl: '/posts/directives/attachment-logs-core/attachment-logs-core-directive.html?$$REVISION$$',
    controller: AttachmentLogsCoreController
  }
}

export { attachmentLogsCore }
